import { buildingQueryKey } from "ApiLayer/Building/queryBuildingModel";
import mutationUpdateCustomPlanMeasures from "ApiLayer/CustomPlans/queryUpdateCustomPlanMeasures";
import { resetBMCRPQueries } from "hooks/invalidateBMCRPQueries";
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation, useQueryClient } from "react-query";
import { processErrorObject } from "utils/errorHandling/errorHandling";
import { showMutationAlert } from "utils/helpers";

export interface UpdateCustomPlanMeasures {
  customPlanId: string;
  measures: CarbonReductionMeasureInput[];
  buildingModelUid: string;
}

export const useUpdateCustomPlanMeasures = () => {
  const accessToken = useAccessToken();
  const alert = useAlert();
  const queryClient = useQueryClient();

  return useMutation({
    onError: (error: any) => {
      const userFriendlyError = processErrorObject(error);
      showMutationAlert(userFriendlyError, alert);
    },
    onSuccess: (_, variables) => {
      alert.success("Custom plan measures updated. Changes visible in a few seconds...");

      queryClient.invalidateQueries([...buildingQueryKey, variables.buildingModelUid]);
      resetBMCRPQueries(variables.customPlanId, queryClient);
    },
    mutationFn: async (data: UpdateCustomPlanMeasures) =>
      mutationUpdateCustomPlanMeasures(accessToken, {
        customPlanId: data.customPlanId,
        measures: data.measures,
      })
  });
}
